import { Space, Tooltip } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import React from 'react'
import styled from 'styled-components'
import { Contract, ContractStatusEnum } from '../../../api'

type ContractTagsProps = {
  contract: Contract
  isArchiving?: boolean
}
export const ContractTags: React.FC<ContractTagsProps> = ({ contract, isArchiving }) => {
  const status = getContractStatus(contract)
  return (
    <Space>
      {contract.archivedAt ? (
        <TagWrapper bg="#767D89">
          <Tooltip title="Archived">
            {isArchiving && <LoadingOutlined />}
            <StatusSpan>{isArchiving ? 'Unarchiving' : 'Archived'}</StatusSpan>
          </Tooltip>
        </TagWrapper>
      ) : isArchiving ? (
        <TagWrapper bg="#767D89">
          <Tooltip title="Archived">
            <LoadingOutlined />
            <StatusSpan>Archiving...</StatusSpan>
          </Tooltip>
        </TagWrapper>
      ) : null}
      {contract.isETLContract && (
        <TagWrapper bg="#3b7cff">
          <Tooltip title="Contract is imported from ETL">
            <StatusSpan>ETL</StatusSpan>
          </Tooltip>
        </TagWrapper>
      )}
      <TagWrapper
        bg={
          status === 'expired'
            ? '#767D89'
            : status === 'expiringSoon'
            ? '#FF0000'
            : status === ContractStatusEnum.Draft
            ? '#9299A6'
            : '#66DE68'
        }>
        <StatusSpan>{CONTRACT_STATUS_LABELS_MAP[status]}</StatusSpan>
      </TagWrapper>
    </Space>
  )
}

const TagWrapper = styled.div<{ bg: string }>`
  background: ${({ bg }) => bg};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 4px;
  height: 16px;
  text-align: center;
`

const StatusSpan = styled.span`
  color: #fff;
  text-transform: uppercase;
  padding: 0 2px;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.05em;
  text-wrap: nowrap;
`

const CONTRACT_STATUS_LABELS_MAP = {
  [ContractStatusEnum.Draft]: 'Draft',
  [ContractStatusEnum.Active]: 'Active',
  [ContractStatusEnum.Pending]: 'Pending',
  [ContractStatusEnum.Expired]: 'Expired',
  expiringSoon: 'Expiring Soon',
}

const getContractStatus = (contract: Contract): ContractStatusEnum | 'expiringSoon' => {
  const expiredTime = new Date(contract.activeDue)
  const daysToExpired = (expiredTime.getTime() - new Date().getTime()) / 86400000
  if (contract.status === ContractStatusEnum.Active && daysToExpired < 90 && daysToExpired > 0) {
    return 'expiringSoon'
  }
  return contract.status!
}
